import {Box, Center, CloseButton, Divider, Flex, LinkBox, LinkOverlay, Text, useColorModeValue} from "@chakra-ui/react";
import {PiButterflyFill} from "react-icons/pi";
import {FiCompass, FiHome, FiSettings, FiStar, FiTrendingUp} from "react-icons/fi";
import {NavItem} from "./NavItem";

const linkItems = [
    {name: 'Home', icon: FiHome, href: "/"},
    {name: 'Frequently visited', icon: FiTrendingUp, href: "/"},
    {name: 'Locations', icon: FiCompass, href: "/"},
    {name: 'Favourites', icon: FiStar, href: "/"},
    {name: 'Settings', icon: FiSettings, href: "/"},
]

export const SidebarContent = ({onClose, ...rest}) => {
    return (
        <Box
            // transition="3s ease"
            bg={useColorModeValue('gray.200', 'gray.900')}
            borderRight="1px"
            borderRightColor={useColorModeValue('gray.200', 'gray.700')}
            w={{base: 'full', md: 60}}
            pos="fixed"
            h="full"
            {...rest}>
            <Flex h="20" alignItems="center" mx="8" justifyContent="space-between">
                <Flex flexDirection={"row"} w={"full"} alignItems={"center"} gap={2}>
                    <Text fontSize="2xl"><PiButterflyFill/></Text>
                    <Text fontSize="2xl" fontFamily="monospace" fontWeight="bold">
                        Butterfly
                    </Text>
                </Flex>
                <CloseButton display={{base: 'flex', md: 'none'}} onClick={onClose}/>
            </Flex>
            <Center>
                <Divider borderBottomColor={useColorModeValue('gray.700', 'gray.200')} w={"80%"}/>
            </Center>
            {linkItems.map((link) => (
                <LinkBox>
                    <NavItem key={link.name} icon={link.icon}>
                        <LinkOverlay href={link.href}>
                            {link.name}
                        </LinkOverlay>
                    </NavItem>
                </LinkBox>
            ))}
        </Box>
    )
};
